import React, { useContext } from "react";
import { DataContext } from '../providers/dataProvider';
import BodyGroup from "./BodyGroup";
import lc from "../cmprtbl.module.scss";

function TableBody( { dataType } ) {
    const ctx = useContext( DataContext );
    const data = ctx.data[dataType];

    return (
        <div className={ lc.tbody }>
            { data.map( ( row, index ) => (
                <BodyGroup rowData={ row } key={ index } />
            ) ) }
        </div>
    );
}

export default TableBody;
